export const sundayUppercase = "Dqa";
export default {sundayUppercase};